import Headings from "../../../components/Texts/Headings";
import InProcessLoanCard from "./InProcessLoanCard";

const InProcessLoanComponent = ({ inprocessLoans }) => {
  return (<>
    <div className="flex flex-col gap-[24px]">
      <Headings
        variant="LoanHeading"
        text="PROCESSNG"
      />
      {inprocessLoans?.map((item, index) =>
        item?.type == "processing" ? <InProcessLoanCard {...item} /> : ""
      )}
      <Headings
        variant="LoanHeading"
        text="APPROVED"
      />
      {inprocessLoans?.map((item, index) =>
        item?.type == "Approved" ? <InProcessLoanCard {...item} /> : ""
      )}
    </div>
  </>)
}
export default InProcessLoanComponent;